
// Format currency function to display amounts nicely
export const formatCurrency = (amount: number | null | undefined) => {
  if (amount === null || amount === undefined) return "—";
  
  try {
    if (amount >= 10000000) {
      return `${(amount / 10000000).toFixed(2)} Cr`;
    } else if (amount >= 100000) {
      return `${(amount / 100000).toFixed(2)} Lac`;
    } else {
      return `${amount.toLocaleString()}`;
    }
  } catch (error) {
    console.error("Error formatting currency:", error);
    return "—";
  }
};
